export class UserDetails {
    constructor(public firstName: string = '',
        public lastName: string = '',
        public phone: string = '',
        public company?: string,
        public mobile?: string,
        public email?: string) {
    }
}

export class OrderReferences {
    constructor(public customerOrderNumber: string,
        public customerReference: string,
        public customerOtherReference: string) {

    }
}
export class DeliveryDetails {
    constructor(public address: string,
        public comments: string) {

    }
}
